import Col from 'react-bootstrap/Col';
import ListGroup from 'react-bootstrap/ListGroup';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import { Link } from 'react-router-dom';

function Main({ activeIndex }) {

 return (
        <Tab.Container id="list-group-tabs-example" defaultActiveKey="#link1">
            <Row>
                <Col sm={12}>
                    <ListGroup>

                        <ListGroup.Item as={Link} action to="https://eprocure.gov.in/eprocure/app" target="_blank" className={`p-3 ${activeIndex==0 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            CPPP Tenders
                        </ListGroup.Item>

                        {/* <h4 className='mt-3 mb-3'>Institute Purchase </h4>

                        <ListGroup.Item as={Link} action to="https://files.iittp.ac.in/pdfs/tenders/2021/PO%20data%20Apr-Sep%202021-22.pdf" target="_blank" className={`p-3 ms-3  mb-2 border-0  border-top border-top ${activeIndex==1 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Purchase Orders April-September 2021
                        </ListGroup.Item>

                        <ListGroup.Item as={Link} action to="https://files.iittp.ac.in/pdfs/tenders/2021/PAC-SS%20List%20Jul-Sep%202021-22.pdf" target="_blank" className={`p-3 ms-3 mb-2  border-0  border-top border-top ${activeIndex == 2 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Single Source/PAC Procurement during July-Sep 2021. 
                        </ListGroup.Item>

                        <h5 className='mt-3 mb-3'>CSRC Purchase</h5>

                        <ListGroup.Item as={Link} action to="https://files.iittp.ac.in/pdfs/tenders/2021/SRC-PO%20data%20Apr-Sep%202021-22.pdf" target="_blank" className={`p-3 ms-3 mb-2  border-0  border-top border-top ${activeIndex == 3 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Purchase Orders April-September 2021
                        </ListGroup.Item>

                        <ListGroup.Item as={Link} action to="https://files.iittp.ac.in/pdfs/tenders/2021/SRC-SS%20List%20July-Sep%202021-22.pdf" target="_blank" className={`p-3 ms-3 mb-2  border-0  border-top border-top ${activeIndex == 4 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Single Source/PAC Procurement during July-Sep 2021. 
                        </ListGroup.Item>


                        <ListGroup.Item as={Link} action to="#" target="_blank" className={`p-3 mt-3 border-top ${activeIndex == 4 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Engineering Unit.
                        </ListGroup.Item> */}


                    </ListGroup>
                </Col>





            </Row>
        </Tab.Container>
    );
}

export default Main;